import { gql } from '@apollo/client'
import { CORE_LAB_RESULT_FIELDS } from '@src/graphql/fragments/labResult'

const FETCH_LAB_RESULTS = gql`
  ${CORE_LAB_RESULT_FIELDS}
  query labResults {
    labResults {
      labResults {
        ...CoreLabResultFields
      }
      labResultsProcessing {
        id
        createdAt
        source
      }
    }
  }
`

export default FETCH_LAB_RESULTS
